import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Icon from "../AppIcon";
import { useAuth } from "context/AuthContext";

export const baseNavigation = [
  // {
  //   label: "Dashboard",
  //   path: "/dashboard",
  //   icon: "LayoutDashboard",
  //   tooltip: "View your dashboard and recent activities",
  // },
  {
    label: "Events",
    path: "/events",
    icon: "Calendar",
    tooltip: "Manage and attend networking events",
    children: [
      { label: "Create Event", path: "/event-creation" },
      { label: "Event Details", path: "/event-details" },
    ],
  },
  {
    label: "Contacts & Leads",
    path: "/contact-directory",
    icon: "Users",
    tooltip: "Manage your professional network",
  },

  // {
  //   label: "Calendar",
  //   path: "/meeting-scheduler",
  //   icon: "Clock",
  //   tooltip: "Schedule and manage meetings",
  // },
];

const SideNavigation = ({ onItemClick, isMobile = false }) => {
  const { role, sellerOrganizationType, userId } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const canShowSellerBusinessActivity =
    role === "Seller" &&
    sellerOrganizationType !== "Supplier" &&
    sellerOrganizationType !== "Other";

  // build menu per render WITHOUT mutating the original array
  const navigationItems = useMemo(() => {
    // Security role gets minimal navigation - only Events
    if (role === "Security") {
      return [
        {
          label: "Events",
          path: "/events",
          icon: "Calendar",
          tooltip: "View assigned events",
        },
      ];
    }

    const items = [...baseNavigation];

    if (role === "Buyer") {
      items.push({
        label: "Outbound Groups & Events",
        path: "/business-activity",
        icon: "Briefcase",
        tooltip: "View outbound groups & events",
      });
    }
    if (canShowSellerBusinessActivity) {
      items.push({
        label: "Inbound Groups & Events",
        path: "/business-activity",
        icon: "Briefcase",
        tooltip: "View inbound groups & events",
      });
    }

    if (userId) {
      items.push({
        label: "Profile Settings",
        path: `/profile/${userId}`,
        icon: "User",
        tooltip: "View your profile",
      });
    }
    return items;
  }, [role, canShowSellerBusinessActivity, userId]);

  const isActiveRoute = (path) =>
    path === "/dashboard"
      ? location.pathname === "/dashboard"
      : location.pathname.startsWith(path);

  return (
    <aside className="hidden lg:flex fixed top-[60px] left-0 w-[210px] h-[calc(100vh-60px)] bg-white border-r border-gray-200 shadow-lg flex-col py-7 px-4 z-[20]">
      <nav className="flex flex-col gap-4 overflow-y-auto">
        {navigationItems?.map((item) => (
          <button
            key={item.path}
            onClick={() => {
              navigate(item.path);
              onItemClick?.();
            }}
            className={`flex items-center gap-2 min-w-0 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
              isActiveRoute(item.path)
                ? "bg-primary/10 text-primary"
                : "text-gray-700 hover:bg-gray-100"
            }`}
            title={item.tooltip}
          >
            <span className="shrink-0">
              <Icon name={item.icon} size={18} />
            </span>
            <span className="flex-1 min-w-0 text-left leading-snug break-words">
              {item.label}
            </span>
          </button>
        ))}
      </nav>
    </aside>
  );
};

export default SideNavigation;
